export default {
  minAutoBitrate: 900000,
  maxMaxBufferLength: 60,
  maxBufferLength: 30,
  maxBufferSize: 2 * 1024 * 1024,
}
